import React from 'react';
import styled from 'styled-components';
import { Form, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { nl2br } from 'helpers';
import { lang } from 'lang';

/**
 * 調整プログラム設定フォームコンポーネント
 */
const SettingForm = (props) => {
  const { word, validate } = lang;
  const { isUpdate, values, onSubmit, formState, register, errors } = props;
  // バリデーションメッセージを定義
  const validationMsg = {
    product_cd: { // プロダクトコード
      required: validate.required,
      maxLength: validate.max_length.replace('%s', 20),
      pattern: validate.product_cd_pattern_1,
      validate: validate.product_cd_pattern_2
    },
    destination: { // 仕向け
      required: validate.required_select.replace('%s', word.destination)
    },
    model: {  // モデル名
      maxLength: validate.max_length.replace('%s', 20)
    },
    alias: {       // 通称
      maxLength: validate.max_length.replace('%s', 20)
    },
    filename: {   // ファイル名
      required: validate.required,
      maxLength: validate.max_length.replace('%s', 20),
      pattern: validate.filename_pattern_1,
    },
  };
  // エラーメッセージをレンダリングする
  const renderMessage = (key, type) => {
    const text = validationMsg[key][type];
    return text && <Alert variant='warning' >{nl2br(text)}</Alert>;
  };
  return (
    <Form onSubmit={onSubmit}>
      <Form.Row>
        <Form.Group as={Col} md="5">
          <Form.Label htmlFor='product-cd'>
            Product code{!isUpdate && <Span>(Mandatory)</Span>}
          </Form.Label>
          <Form.Control 
            type='text'
            id='product-cd'
            name='product_cd'
            disabled={isUpdate}
            defaultValue={isUpdate ? values.product_cd : ''}
            className={errors.product_cd ? 'input-warning' : ''}
            maxLength={20}
            ref={
              register({ 
                required: true,
                maxLength: 20,
                pattern: /^.[L|N|E|P]/,
                validate: (product_cd) => product_cd.match(/^[a-zA-Z0-9]{8}$/) !== null ? true : false, 
              })
            }
          ></Form.Control>
        </Form.Group>
        <Form.Group as={Col} md="5">
          <Form.Label>
            Region<Span>(Mandatory)</Span>
          </Form.Label>
          <Div>
            <RadioButton
              id="destination-us"
              type="radio"
              label="US"
              name="destination"
              value="US"
              defaultChecked={(isUpdate && values.destination === 'US') ? true : false}
              ref={
                register({ 
                  required: true,
                })
              }
            />
            <RadioButton
              id="destination-jp"
              type="radio"
              label="JP"
              name="destination"
              value="JP"
              defaultChecked={(isUpdate && values.destination === 'JP') ? true : false}
              ref={
                register({ 
                  required: true
                })
              }
            />
            <RadioButton
              id="destination-EU"
              type="radio"
              label="EU"
              name="destination"
              value="EU"
              defaultChecked={(isUpdate && values.destination === 'EU') ? true : false}
              ref={
                register({ 
                  required: true
                })
              }
            />
            <RadioButton
              id="destination-AU"
              type="radio"
              label="AU"
              name="destination"
              value="AU"
              defaultChecked={(isUpdate && values.destination === 'AU') ? true : false}
              ref={
                register({ 
                  required: true
                })
              }
            />
          </Div>
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} md="5" className='form-group_alert'>
          {errors.product_cd && renderMessage('product_cd', errors.product_cd.type)}
        </Form.Group>
        <Form.Group as={Col} md="5" className='form-group_alert'>
          {errors.destination && renderMessage('destination', errors.destination.type)}
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} md="5">
          <Form.Label htmlFor='model'>
            Product Name
          </Form.Label>
          <Form.Control
            id='model'
            type='text'
            name='model'
            defaultValue={isUpdate ? values.model : ''}
            className={errors.model ? 'input-warning' : ''}
            maxLength={20}
            ref={
              register({ 
                minLength: 1,
                maxLength: 20,
              })
            }
          ></Form.Control>
        </Form.Group>
        <Form.Group as={Col} md="5">
          <Form.Label htmlFor='alias'>
            Name
          </Form.Label>
          <Form.Control
            id='alias'
            type='text'
            name='alias'
            defaultValue={isUpdate ? values.alias : ''}
            className={errors.alias ? 'input-warning' : ''}
            maxLength={20}
            ref={
              register({ 
                minLength: 1,
                maxLength: 20,
              })
            }
          ></Form.Control>
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} md="5" className='form-group_alert'>
          {errors.model && renderMessage('model', errors.model.type)}
        </Form.Group>
        <Form.Group as={Col} md="5" className='form-group_alert'>
          {errors.alias && renderMessage('alias', errors.alias.type)}
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} md="5">
          <Form.Label htmlFor='filename'>
            File name without version{!isUpdate && <Span>(Mandatory)</Span>}
          </Form.Label>
          <Form.Control
            id='filename'
            type='text'
            name='filename'
            defaultValue={isUpdate ? values.filename : ''}
            disabled={isUpdate}
            className={errors.filename ? 'input-warning' : ''}
            maxLength={20}
            ref={
              register({ 
                required: true,
                maxLength: 20,
                pattern: /^[a-zA-Z0-9-_.]*$/
              })
            }
          ></Form.Control>
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} md="5" className='form-group_alert'>
          {errors.filename && renderMessage('filename', errors.filename.type)}
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <SubmitButton
          data-testid='submit-button'
          type='submit'
          disabled={formState.isSubmitting}
        >
          {isUpdate ? 'Submit' : 'Add'}
        </SubmitButton> 
      </Form.Row>
    </Form>
  );
};
SettingForm.propTypes = {
  isUpdate: PropTypes.bool,
  register: PropTypes.func,
  onSubmit: PropTypes.func,
  values: PropTypes.object,
  formState: PropTypes.object,
  errors: PropTypes.object,
};
SettingForm.defaultProps = {
  isUpdate: false,
  values: {},
};
const RadioButton = styled(Form.Check)`
  margin-left: 10px;
`;
const Div = styled.div`
  margin-bottom: 8px;
  padding-top: 9px;
  height: 40px;
  display: flex;
  background-color:white;
`;
const SubmitButton = styled(Button)`
  margin-left: 5px;
  margin-bottom: 20px;
`;
const Span = styled.span`
  color: red;
  margin-left:10px;
`;

export default SettingForm;
